import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import {routes} from "../config";
import classNames from 'classnames';


function Sitemap(props) {
  const {classes, className} = props;

  const links = [
    {url: routes.home, text: 'Home'},
    {url: routes.work, text: 'Work'},
    {url: routes.services, text: 'Services'},
    {url: routes.team, text: 'Team'},
    {url: routes.blog, text: 'Blog'},
    {url: routes.contact, text: 'Contact'},
  ];

  return (
    <ul className={classNames(classes.sitemap, className)}>
      {links.map((link, index) =>
        <li key={index} className={classes.item}>
          <Link className={classes.link} to={link.url}>{link.text}</Link>
        </li>
      )}
    </ul>
  );
}

export default withStyles((theme) => ({
  sitemap: {
  },
  item: {
    marginBottom: theme.spacing.unit * 2,
  },
  link: {
    color: theme.palette.secondary.main,
    ...theme.typography.hg14bu(theme),
  },
  [theme.breakpoints.up(768)]: {
    sitemap: {
      display: 'flex',
      margin: -theme.spacing.unit * 2,
    },
    item: {
      margin: theme.spacing.unit * 2,
    },
  }
}))(Sitemap);




// WEBPACK FOOTER //
// ./src/parts/Sitemap.js